import React, { useId } from 'react';
import { Icon } from 'components/ui';
import styles from './SidebarSearch.module.scss';

export interface ISidebarSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export default function SidebarSearch({
  value,
  onChange,
}: ISidebarSearchProps) {
  const inputId = useId();

  return (
    <div className={styles.search}>
      <Icon name="search" size={18} className={styles.icon} aria-hidden />
      <input
        id={inputId}
        type="search"
        className={styles.input}
        value={value}
        onChange={event => onChange(event.target.value)}
        placeholder="Search menu…"
        aria-label="Search navigation links"
        enterKeyHint="search"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
      />
    </div>
  );
}
